import React from "react";
import * as S from '../scss/theme';
import {
  ComposedChart, Line, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';

const Example2 = () => {
  const data = [
    { name: '노벨', value: 70 },
    { name: '잡스', value: 10 },
    { name: '현대', value: 8 },
    { name: '유비', value: 40 },
  ];

  return (
    <S.Section>
      <div>
        {/* ✅ 차트 제목 */}
        <h2 style={{
          textAlign: 'center',
          color: '#FF0000',
          marginBottom: '20px',
          fontWeight: 'bold'
        }}>
          학생 검사 결과
        </h2>

        <ResponsiveContainer width="100%" height={300}>
          <ComposedChart
            data={data}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis 
                domain={[0, 'dataMax + 10']}  
                tickFormatter={(value) => value === 0 ? '' : value}
            />
            <Tooltip />

            {/* ✅ 내부 채움 - 단일 색상 적용 */}
            <Area
              type="linear"
              dataKey="value"
              stroke="none"
              fill="#FF0000"
              fillOpacity={0.3}
              name="학생 검사 결과"
            />

            {/* 외곽선 Line */}
            <Line
              type="linear"
              dataKey="value"
              name="학생 검사 결과"
              stroke="#FF0000"
              strokeWidth={3}
              dot={{ r: 5 }}
              activeDot={{ r: 7 }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </S.Section>
  );
};

export default Example2;
